/**
 * flight — the English half, typed against the German module, so a
 * missing or misspelled key is a type error in this file.
 */
import type { flight as de_flight } from '../de/flight';

export const flight: Record<keyof typeof de_flight, string> = {
  /* ---------------- editor ---------------- */
  'ed.status.local': 'this browser only',
  'ed.status.dirty': 'unsaved changes',
  'ed.status.saving': 'saving …',
  'ed.status.saved': 'saved',
  'ed.status.error': 'saving failed',
  'ed.status.conflict': 'conflict',
  'ed.autocalc': 'Compute values automatically',
  'ed.export': 'Export plan',
  'ed.import': 'Import plan',
  'ed.clear': 'Clear',
  'ed.share': 'Share',
  'ed.more': 'More',
  'ed.title.ph': 'Title of the plan',
  'ed.pdf.busy': 'Creating PDF …',
  'ed.pdf': 'Download PDF',
  'ed.conflict.text': 'This plan was changed elsewhere. Your version is still here and was not overwritten.',
  'ed.conflict.take': 'Take the server version',
  'ed.conflict.keep': 'Keep my version',
  'ed.saveerr': 'Saving to the server failed: {error} · The local copy is up to date.',
  'ed.retry': 'Try again',
  'ed.sharelink': 'Share link: {url}',
  'ed.copy': 'Copy',
  'ed.close': 'Close',
  'ed.confirm.import': 'Replace the current entries with the contents of the file?',
  'ed.confirm.clear': 'Delete all entries?',
  'ed.notavailable': 'Plan not available',
  'ed.toplans': 'To the plan list',

  /* ---------------- the workspace ---------------- */
  'insp.tabs': 'View',
  'insp.route': 'Route',
  'insp.navlog': 'Nav log',
  'insp.weather': 'Weather',
  'insp.terrain': 'Terrain',
  'insp.form': 'Form',
  'insp.export': 'Export',
  'insp.collapse': 'Collapse panel',
  'insp.expand': 'Expand panel',
  'summary.aria': 'The flight in numbers',
  'summary.eta': 'ETA',
  'summary.fuel': 'Fuel',
  'summary.sh': 'SA max',
  'flight.back': 'Back to the flights',
  'flight.tab.map': 'Map',
};
